import { defineStore } from '@kidzonet/pinia'
import { deleteSession, getCurrentUserSessions } from '@kidzonet/ts-api-control-sessions'

export interface sessionItemInterface {
    sessionId: string
    userAgent: string
    createdAt: string
    expiresAt: string
    lastIP: string
    lastActivity: string
}
type idType = string | number | null

export const useSessionsStore = defineStore('account-sessions', {
    state: () => {
        const sessions: sessionItemInterface[] = []
        return {
            sessions,
            isSessionLoading: false,
        }
    },
    actions: {
        async getSessions () {
            this.isSessionLoading = true
            const result = await getCurrentUserSessions() || []
            this.$patch({
                sessions: result,
                isSessionLoading: false,
            })
        },
        async deleteSession (id: idType) {
            if (!id) {
                return true
            }
            deleteSession(String(id))
            this.sessions = this.sessions.filter(({ sessionId }) => sessionId !== id)
            return true
        },
    },
})
